(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information.js');
'use strict';

const {
  BigIcon
} = svs.myProfile.react.shared.components;
const {
  TranscriptPanel
} = svs.myProfile.react.pages.myInformation.transcript;
const {
  MyInformationPanel
} = svs.myProfile.react.pages.myInformation.myInformation;

const MyInformation = _ref => {
  let {
    isAddAlias,
    isChangeEmail,
    isChangeMobile,
    isTranscriptLink
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(BigIcon, {
    icon: "user"
  }), React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(MyInformationPanel, {
    isAddAlias: isAddAlias,
    isChangeEmail: isChangeEmail,
    isChangeMobile: isChangeMobile
  })), React.createElement(TranscriptPanel, {
    isTranscriptLink: isTranscriptLink
  }));
};
svs.myProfile.react.pages.myInformation.MyInformation = MyInformation;

 })(window);